(function () {
    'use strict';

    angular.module('NaviaqWebApp').directive('finalReportLegalPageAbyssPageTwoDirective', finalReportLegalPageAbyssPageTwoDirective);

    finalReportLegalPageAbyssPageTwoDirective.$inject = [];
    function finalReportLegalPageAbyssPageTwoDirective() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/report/clients/Abyss/finalReportComponents/final-report-legal-page-abyss-page-two.html',
            scope: {
                data: '=data'
            },
            link: function (scope, element, attrs) {
            },
        };
    }
})();
